import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  GetRequest,
  PostRequest,
  DeleteRequest,
  PutRequest,
} from "../../repository/RequestMaker";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashCan, faEdit } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-modal";
import "./Companies.css";

Modal.setAppElement("#root");

export default function CompanyType() {
  const [companyTypes, setCompanyTypes] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    company_id: "",
  });
  const [deleteId, setDeleteId] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchCompanyTypes();
    fetchCompanies();
  }, []);

  const fetchCompanyTypes = () => {
    setLoading(true);
    GetRequest("/company_type")
      .then((response) => {
        setCompanyTypes(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch company types", error);
        setLoading(false);
      });
  };

  const fetchCompanies = () => {
    GetRequest("/companies")
      .then((response) => {
        setCompanies(response.data);
      })
      .catch((error) => {
        console.error("Failed to fetch companies", error);
      });
  };

  const onDeleteClick = (id) => {
    setDeleteId(id);
    setDeleteModalIsOpen(true);
  };

  const handleDelete = () => {
    DeleteRequest(`/company_type/${deleteId}`)
      .then(() => {
        fetchCompanyTypes();
        closeDeleteModal();
      })
      .catch((error) => {
        console.error("Failed to delete company type", error);
        closeDeleteModal();
      });
  };

  const formatDate = (dateString) => {
    return moment(dateString).format("YYYY-MM-DD HH:mm:ss");
  };

  const openModal = (companyType = null) => {
    if (companyType) {
      setFormData({
        id: companyType.id,
        name: companyType.name,
        company_id: companyType.company_id || "",
      });
      setIsEditMode(true);
    } else {
      setFormData({
        id: "",
        name: "",
        company_id: "",
      });
      setIsEditMode(false);
    }
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setError("");
  };

  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false);
    setDeleteId(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const duplicate = companyTypes.some(
      (type) =>
        type.name === formData.name &&
        type.company_id === formData.company_id &&
        (isEditMode ? type.id !== formData.id : true)
    );

    if (duplicate) {
      setError(
        "This company type name already exists for the selected company."
      );
      return;
    }

    const request = isEditMode
      ? PutRequest(formData, `/company_type/${formData.id}`)
      : PostRequest(formData, "/company_type");

    request
      .then(() => {
        fetchCompanyTypes();
        closeModal();
      })
      .catch((error) => {
        console.error("Failed to submit form", error);
      });
  };

  return (
    <div className="company-type-container">
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <button className="btn-add" onClick={() => openModal()}>
          <FontAwesomeIcon icon={faPlus} /> Add New Company Type
        </button>
      </div>
      {loading ? (
        <p style={{ textAlign: "center" }}>Wird geladen...</p>
      ) : (
        <div className="card-admin animated fadeInDown">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Company</th>
                <th>Erstellungsdatum</th>
                <th>Bearbeitungsdatum</th>
                <th>Aktionen</th>
              </tr>
            </thead>
            <tbody>
              {companyTypes.map((type) => (
                <tr key={type.id}>
                  <td>{type.id}</td>
                  <td>{type.name}</td>
                  <td>
                    {companies.find((c) => c.id === type.company_id)?.name ||
                      "N/A"}
                  </td>
                  <td>{formatDate(type.created_at)}</td>
                  <td>{formatDate(type.updated_at)}</td>
                  <td>
                    <button
                      className="btn-edit"
                      onClick={() => openModal(type)}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    &nbsp;
                    <button
                      className="btn-delete"
                      onClick={() => onDeleteClick(type.id)}
                    >
                      <FontAwesomeIcon icon={faTrashCan} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={{
          overlay: {
            zIndex: 9999,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            maxHeight: "80%",
            overflow: "auto",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <h5>{isEditMode ? "Update company type" : "Add new company type"}</h5>
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleFormSubmit} className="modal-form">
          <div className="form-group">
            <label>Name:</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label>Company:</label>
            <select
              name="company_id"
              value={formData.company_id}
              onChange={handleInputChange}
              className="form-control"
            >
              <option value="">Select a Company</option>
              {companies.map((company) => (
                <option key={company.id} value={company.id}>
                  {company.name}
                </option>
              ))}
            </select>
          </div>
          <div style={{ paddingTop: "15px" }} className="modal-actions">
            <button type="submit" className="btn-submit">
              {isEditMode ? "Update" : "Add"}
            </button>
            <button type="button" className="btn-cancel" onClick={closeModal}>
              Cancel
            </button>
          </div>
        </form>
      </Modal>
      <Modal
        isOpen={deleteModalIsOpen}
        onRequestClose={closeDeleteModal}
        style={{
          overlay: {
            zIndex: 9999,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "40%",
            maxHeight: "80%",
            overflow: "auto",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <h5>Are you sure you want to delete this company type?</h5>
        <div className="modal-actions">
          <button className="btn-delete" onClick={handleDelete}>
            Delete
          </button>
          <button className="btn-cancel" onClick={closeDeleteModal}>
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  );
}
